import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const BillingPageSkeleton = () => (
  <>
    <Styles.InvoicesContainer>
      {Array.from({ length: 8 }).map((_, index) => (
        <Styles.InvoiceItem key={index}>
          <Styles.Header>
            <Styles.HeaderGroup>
              <Skeleton variant="rounded" width={70} height={20} />
              <Skeleton variant="text" width={80} height={20} />
            </Styles.HeaderGroup>
            <Styles.HeaderGroup>
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="rounded" width={90} height={24} />
            </Styles.HeaderGroup>
          </Styles.Header>
          <Styles.DetailLine>
            <Styles.DatesContainer>
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="text" width={100} height={16} />
              <Skeleton variant="text" width={140} height={16} />
            </Styles.DatesContainer>
            <Styles.AmountContainer>
              <Skeleton variant="text" width={100} height={16} />
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="text" width={80} height={20} />
            </Styles.AmountContainer>
          </Styles.DetailLine>
        </Styles.InvoiceItem>
      ))}
    </Styles.InvoicesContainer>
    <Styles.PaginationContainer>
      <Skeleton variant="circular" width={24} height={24} />
      <Skeleton variant="text" width={100} height={16} />
      <Skeleton variant="circular" width={24} height={24} />
    </Styles.PaginationContainer>
  </>
)

export default BillingPageSkeleton
